export default "__VITE_ASSET__a1be6bab__"